export default "__VITE_ASSET__CYvTOERh__"